import { FeatureFlags } from '@shared/utils/constants';
import { isMeratusTcInOrOut } from '@shared/utils/meratus';
import useFeatureFlag from '@client/utils/hooks/useFeatureFlag';

const useIsMeratusTcInOrOut = (fixtureType?: string | null) => {
	const isMeratus = useFeatureFlag(FeatureFlags.MERATUS);

	return isMeratusTcInOrOut(isMeratus, fixtureType ?? '');
};

export default useIsMeratusTcInOrOut;
